import VueRouter from 'vue-router'

const Dashboard = () => import( /* webpackChunkName: "js/pages/user-area/dashboard" */ './user-area/pages/Dashboard')
const HiddenEstates = () => import( /* webpackChunkName: "js/pages/user-area/hidden-estates" */ './user-area/pages/HiddenEstates')
const SavedEstates = () => import( /* webpackChunkName: "js/pages/user-area/saved-estates" */ './user-area/pages/SavedEstates')
const SavedSearches = () => import( /* webpackChunkName: "js/pages/user-area/saved-searches" */ './user-area/pages/SavedSearches')
const UserProfile = () => import( /* webpackChunkName: "js/pages/user-area/user-profile" */ './user-area/pages/UserProfile')
const PageNotFound = () => import( /* webpackChunkName: "js/pages/user-area/page-not-found" */ './user-area/pages/PageNotFound')

const routes = (typeof(window.user_routes) !== "undefined") ? 
    [
        {
            path: window.user_routes.dashboard,
            component: Dashboard,
        },
        {
            path: window.user_routes.profile,
            component: UserProfile,
        },
        {
            path: window.user_routes.saved_estates,
            component: SavedEstates,
        },
        {
            path: window.user_routes.hidden_estates,
            component: HiddenEstates,
        },
        {
            path: window.user_routes.saved_searches,
            component: SavedSearches,
        },
        {
            path: '*',
            component: PageNotFound,
        }
    ] :
    ''

export default new VueRouter({
    routes,
    mode: 'history',
    base: window.user_prefix,
    linkActiveClass: 'is-active',
})
